import { useState } from "react";
import PrimeModal from "../../../ui-lib/components/PrimeModal/PrimeModal";
import useTranslations from "../../../core/i18n/useTranslations";
import TextInput from "../../../ui-lib/components/Inputs/TextInput";
import useUser from "../../../core/user/useUser";
import Button from "../../../ui-lib/components/Button/Button";
import { ObjectActivationData } from "../../../core/api/objects/types";
import { activateSubscription } from "../../../core/api/objects/objects";
import { Spacer } from "../../../components/Layout/Layout";

export const ActivationCodeModal = ({
  objectId,
  subscriptionData,
  fetchObjectSubscription,
}: {
  objectId: string;
  subscriptionData: ObjectActivationData;
  fetchObjectSubscription: () => Promise<void>;
}) => {
  const t = useTranslations();
  const { authenticatedRequest } = useUser();

  const [activationCode, setActivationCode] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showAlarmCodeModal, setShowAlarmCodeModal] = useState(false);

  const onSubmit = async () => {
    setIsLoading(true);
    await activateSubscription(objectId, authenticatedRequest, activationCode);
    setIsLoading(false);
    setShowAlarmCodeModal(false);
    fetchObjectSubscription();
  };

  return (
    <>
      <Button
        text={t("Common:labels_use_code")}
        variant="secondary"
        onClick={() => setShowAlarmCodeModal(true)}
        disabled={!subscriptionData.subscriptionNotSet}
      />
      <PrimeModal
        withFooter
        withHeader
        loading={isLoading}
        fixedWidth="576px"
        header={t("Common:labels_activation_code")}
        isOpen={showAlarmCodeModal}
        onClose={() => setShowAlarmCodeModal(false)}
        submitBtn={{ text: t("Objects:label_use_code"), onClick: onSubmit }}
        cancelBtn={{
          text: t("Common:cancel"),
          onClick: () => setShowAlarmCodeModal(false),
        }}
      >
        <p>{t("Common:modal_activation_code")}</p>
        <Spacer size={16} />
        <TextInput
          label={t("Objects:labels_subscription_code")}
          value={activationCode}
          onChange={(e) => setActivationCode(e.target.value)}
        />
      </PrimeModal>
    </>
  );
};
